import _ from 'lodash';

export const FILTER_TYPES = {
  BOARD: 'board',
  ISSUE_TYPES: 'issueTypes',
  EPIC: 'epic',
  LABEL: 'label',
  FIELD: 'field',
  FIELDS_DEFINITIONS: 'fieldsDefinitions',
  PROJECTS: 'projects',
  TEAMS: 'teams',
  FIX_VERSION: 'fixVersion',
  SHORTCUT_LABEL: 'shortcutLabels',
  SHORTCUT_EPICS: 'shortcutEpics',
  STATUSES: 'jiraState',
  ORGANIZATION_TEAMS: 'team',
  ORGANIZATION_PDT: 'organization_pdt',
  AZURE_BOARDS_PROJECT_TEAM_AREAS: 'project_team_areas',
  ISSUE_PARENT_1: 'issue_parent_1',
  ISSUE_PARENT_2: 'issue_parent_2',
  KEYWORDS: 'keywords',
  DYNAMIC_ISSUES: 'dynamic_issues'
};
export const resolveFilterValue = values =>
  values.map(value => ({ id: value, title: value }));
export const filterFormatter = {
  [FILTER_TYPES.PROJECTS]: data =>
    _.map(data, ({ entity_id, entity_name }) => ({
      id: entity_id,
      title: entity_name
    })),
  [FILTER_TYPES.TEAMS]: data =>
    _.map(data, ({ entity_id, entity_name }) => ({
      id: entity_id,
      title: entity_name
    })),
  [FILTER_TYPES.SHORTCUT_LABEL]: data =>
    _.map(data, ({ entity_id, entity_name }) => ({
      id: entity_id,
      title: entity_name
    })),
  [FILTER_TYPES.SHORTCUT_EPICS]: data =>
    _.map(data, ({ entity_id, entity_name }) => ({
      id: entity_id,
      title: entity_name
    })),
  [FILTER_TYPES.BOARD]: data =>
    _.map(data, ({ id, name }) => ({
      id,
      title: name
    })),
  [FILTER_TYPES.FIX_VERSION]: data =>
    _.map(data, ({ id, name }) => ({
      id,
      title: name
    })),
  [FILTER_TYPES.EPIC]: data =>
    resolveFilterValue(_.map(data, ({ key }) => key)),
  [FILTER_TYPES.LABEL]: data =>
    resolveFilterValue(_.map(data, item => item?.name || null).filter(Boolean)),
  [FILTER_TYPES.FIELD]: data =>
    _.map(data, ({ id, name }) => ({ id, title: name })),
  [FILTER_TYPES.ISSUE_TYPES]: data =>
    _.map(data, issueType => ({
      id: _.get(issueType, 'id'),
      title: _.get(issueType, 'name')
    })),
  [FILTER_TYPES.ORGANIZATION_TEAMS]: data =>
    _.map(data, team => {
      const { id, name, initials, color } = team;
      return { id, title: name, initials, color, entity: team };
    })
};
